import {Trans} from 'react-i18next';

import {Icons} from 'app/constants/icons';

export const VerifyMessage = () => {
  return (
    <div className="flex w-full items-center justify-center gap-2.5 rounded-lg bg-[#161A20] px-3.5 py-2.5 light:bg-gray-50">
      <Icons.shield className="flex-none" />

      <span className="color-gray-500 text-sm leading-normal mobile:text-center mobile:text-xs mobile:leading-normal">
        <Trans i18nKey="connect.verify" />{' '}
        <span className="text-success">app.elys.network</span>
      </span>
    </div>
  );
};
